import React from 'react';
import PropTypes from 'prop-types';
import {
  AdditionalInfo, ClearButton, Container, Content, Counter, ErrorMessage,
} from './css';

const TextArea = ({
  hideCounter,
  input,
  placeholder,
  maxLength,
  noMinHeight = false,
  isClearable,
  additionalInfo,
  meta: { touched, error } = {},
}) => {
  const handleInput = (e) => {
    e.target.style.height = 'inherit';
    e.target.style.height = `${e.target.scrollHeight}px`;
    input.onChange(e.target.value);
  };

  const clear = (e) => {
    e.preventDefault();
    input.onChange('');
  };

  return (
    <Container>
      <Content
        {...input}
        placeholder={placeholder}
        onChange={handleInput}
        maxLength={maxLength}
        rows="1"
        noMinHeight={noMinHeight}
        isClearable={isClearable}
      />
      {!hideCounter && (
      <Counter>
        {input.value.length}
        /
        {maxLength}
      </Counter>
      )}
      {(isClearable && input.value)
                && (
                <ClearButton onClick={clear}>
                  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    {/* eslint-disable-next-line max-len */}
                    <path d="M3.03033 1.46967C2.73744 1.17678 2.26257 1.17677 1.96967 1.46967C1.67678 1.76256 1.67677 2.23743 1.96967 2.53033L3.03033 1.46967ZM13.9695 14.5303C14.2624 14.8232 14.7372 14.8232 15.0301 14.5303C15.323 14.2374 15.323 13.7626 15.0301 13.4697L13.9695 14.5303ZM15.0303 2.53033C15.3232 2.23743 15.3232 1.76256 15.0303 1.46967C14.7374 1.17677 14.2626 1.17678 13.9697 1.46967L15.0303 2.53033ZM1.96985 13.4697C1.67696 13.7626 1.67697 14.2374 1.96986 14.5303C2.26276 14.8232 2.73763 14.8232 3.03052 14.5303L1.96985 13.4697ZM1.96967 2.53033L7.96967 8.53042L9.03033 7.46977L3.03033 1.46967L1.96967 2.53033ZM7.96967 8.53042L13.9695 14.5303L15.0301 13.4697L9.03033 7.46977L7.96967 8.53042ZM13.9697 1.46967L7.96967 7.46977L9.03033 8.53042L15.0303 2.53033L13.9697 1.46967ZM7.96967 7.46977L1.96985 13.4697L3.03052 14.5303L9.03033 8.53042L7.96967 7.46977Z" fill="black" />
                  </svg>
                </ClearButton>
                )}
      {
                touched
                  ? error
                    ? <ErrorMessage>{error}</ErrorMessage>
                    : additionalInfo && <AdditionalInfo>{additionalInfo}</AdditionalInfo>
                  : additionalInfo && <AdditionalInfo>{additionalInfo}</AdditionalInfo>
            }
    </Container>
  );
};

TextArea.propTypes = {
  hideCounter: PropTypes.bool,
  input: PropTypes.shape({
    onChange: PropTypes.func,
    value: PropTypes.string,
  }),
  placeholder: PropTypes.string,
  maxLength: PropTypes.number,
  noMinHeight: PropTypes.bool,
  isClearable: PropTypes.bool,
  additionalInfo: PropTypes.node,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
};

export default TextArea;
